import { render, staticRenderFns } from "./LoginForm.vue?vue&type=template&id=3391f1a2&scoped=true"
import script from "./LoginForm.vue?vue&type=script&lang=ts"
export * from "./LoginForm.vue?vue&type=script&lang=ts"
import style0 from "./LoginForm.vue?vue&type=style&index=0&id=3391f1a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3391f1a2",
  null
  
)

export default component.exports